export var BooleanFilterType;
(function (BooleanFilterType) {
    BooleanFilterType[BooleanFilterType["No"] = 0] = "No";
    BooleanFilterType[BooleanFilterType["Yes"] = 1] = "Yes";
    BooleanFilterType[BooleanFilterType["Both"] = 2] = "Both";
})(BooleanFilterType || (BooleanFilterType = {}));
